module.exports = __webpack_public_path__ + "img/small-pic3.6155e8b0.png";